import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import CryptoJS from 'crypto-js';
import $ from 'jquery';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-touch-screen-keyboard/lib/Keyboard.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/cardsummary.css';
import '../../stylesheet/dashboard.css';
import '../../stylesheet/tabdesign.css';
import '../../stylesheet/virtualkeyboard.css';
// import AuthNavbar from '../navigation/authnavigation.jsx'
import AdminNavbar from '../navigation/adminnavigation.jsx';
import CardStatusModal from './cardstatus';
import ShadowCard from './shadowcard';
const styles = {
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    underlineStyle1: {
        borderTop: "none rgb(224, 224, 224)",
        borderLeft: "none rgb(224, 224, 224)",
        borderRight: "none rgb(224, 224, 224)",
        borderBottom: "1px solid rgb(224, 224, 224)",
        bottom: "22px",
        position: "relative",
        width: "100%"

    },
    buttonStyle: {
        background: "rgba(41, 40, 40, 0.87)",
    }
}

const mapStateToProps = state =>
    ({
        cardDetailState: state.getCardDetailsReducer.cardDetailState,
        useridInfoState: state.getUserIdInfoReducer.useridInfoState,
        mobileNoInfoState: state.getMobileNoInfoReducer.mobileNoInfoState,
        cardNoInfo: state.getCardNoDetailsReducer.cardDetailState,
        customerListState: state.customerListReducer.customerListState,
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
    })
const mapDispatchToProps = dispatch =>
    ({
        getCardDetails(cardRefNo) {
            dispatch(
                actions.getCardDetailAction(cardRefNo)
            )
        },
        getUserIdDetails(userId, history) {
            dispatch(
                actions.userIdInfoAction(userId, history)
            )
        },
        getMobileInfoDetails(mobileNo,history) {
            dispatch(
                actions.mobileNoInfoAction(mobileNo,history)
            )
        },
        getCustomerList() {
            dispatch(actions.getCustomerListAction())
        },
        getCardNoDetails(cardNo, toggler){
            dispatch(actions.getCardNoDetailsAction(cardNo, toggler))
        },
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
    })



class CardSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: localStorage.getItem("tab") || "tab1",
            disabled: true,
            disabledUserSearch: true,
            disabledMobileSearch: true,
            open: true,
            display: 'card',
            customers: [],
            selected: {},
            loader: true,
            cardNo: '',
            tendigitcardNo:'',
            disabledTendigitCardNoSearch: true,
            disabledCardNoSearch: true,
            baseUrl: "",
            todatestate: true,
            // appClass: 'active',
            customerId:'',
            appId: localStorage.getItem('applicationId'),
            useridInfoState:[],
            cardReferenceId: '',
            cardBin:'',
            statusData: ''
        }
        this.renderCustomers = this.renderCustomers.bind(this)
        this.handleCardNo = this.handleCardNo.bind(this)
    }
    handleChange(e) {
        this.setState({
            selectedOption: e.target.value
        })
    }
    closeStatusModal = () => {
        this.setState({ statusData: '' })
    }
    handlecardactivity = () => {
     
        if (Date.parse(this.state.activityToDate) <= Date.parse(this.state.activityFromDate)) {
            this.setState({
                todatestate: false,
            })
        }
        else {

            this.setState({
                activityFromDate: this.state.activityFromDate,
                activityToDate: this.state.activityToDate,
                applicationId: "myrewards",
                cardDetailsId: this.state.cardDetailsId,
                statementPeriod: 0

            }, () => {
                this.setState({
                    loader: true
                })
                this.props.fetchCardActivity(this.state.cardDetailsId, this.state.activityFromDate, this.state.activityToDate, this.state.statementPeriod, this.state.transactionType)

            }, () => {
                this.setState({
                    loader: false
                })
            })
        }
    }

    async componentWillMount() {
     
      await this.props.getCustomerList()
        if (this.props.customerListState.body && this.props.customerListState.body.length > 0 ) 
        this.props.customerListState.body.map((value,i) =>
      {
          if(localStorage.getItem('applicationId')===null ){

          localStorage.setItem('serviceUrl',this.props.customerListState.body[0].baseURL)
          localStorage.setItem('publicKey',this.props.customerListState.body[0].publickey)
          localStorage.setItem('applicationId',this.props.customerListState.body[0].applicationId)
          localStorage.setItem('cardBin',this.props.customerListState.body[0].programBIN)
          }
        // if(localStorage.getItem('applicationId')===null ){
       

          this.setState({
              customerId: this.props.customerListState.body[0].customerId,
              appId: localStorage.getItem('applicationId'),
          })
        })
        this.props.fetchPublicKey()
    }
     componentDidMount() {
      this.props.getCustomerList()
        if (this.props.customerListState.body && this.props.customerListState.body.length > 0 ) 
          this.props.customerListState.body.map((value,i) =>
        {
            if(localStorage.getItem('applicationId') === null ) {

            localStorage.setItem('serviceUrl',this.props.customerListState.body[0].baseURL)
            localStorage.setItem('publicKey',this.props.customerListState.body[0].publickey)
            localStorage.setItem('applicationId',this.props.customerListState.body[0].applicationId)
          
            }
          if(localStorage.getItem('applicationId') === null ){
            this.setState({
                customerId: this.props.customerListState.body[0].customerId,
                appId: localStorage.getItem('applicationId'),
            })
          } 
          })
          
        if (this.props.cardDetailState.status === 401 || this.props.useridInfoState === 401 || this.props.mobileNoInfoState === 401 || this.props.customerListState.status === 401) {
            localStorage.clear();
            this.props.history.push('/SessionOut')
        }
        this.props.fetchPublicKey()
      
    }
    componentDidUpdate() {
        if (this.props.customerListState.body && (this.props.customerListState.body !== this.state.customers)) {
            this.setState({ customers: this.props.customerListState.body, 
                customerId: this.props.customerListState.body[0].customerId,
                appId: localStorage.getItem('applicationId'),
                loader: false })
        }
    }
    changeCardNo = (e, value) => {
        if (e.target.name === "cardNo" && value.length !== 0) {

            this.setState({
                cardNo: value,
                disabledCardNoSearch: false
            })
        }
        else {
            this.setState({
                disabledCardNoSearch: true
            })
        }

    }
    changeTenDigitCardNo = (e, value) => {
        if (e.target.name === "tendigitcardNo" && value.length !== 0) {

            this.setState({
                tendigitcardNo: value,
                disabledTendigitCardNoSearch: false
            })
        }
        else {
            this.setState({
                disabledTendigitCardNoSearch: true
            })
        }

    }
    cardNumber = (e, value) => {
        // var regx = /^[0-9]{8,15}$/
        if (e.target.name === 'cardNumber' && e.target.value.length !== 0) {
            this.setState({
                cardNumber: e.target.value,
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }
    }
    userId = (e, value) => {
        if (e.target.name === "userId" && value.length !== 0) {

            this.setState({
                userName: value,
                disabledUserSearch: false
            })
        }
        else {
            this.setState({
                disabledUserSearch: true
            })
        }
    }

    mobileNo = (e, value) => {
        if (e.target.name === "mobileNo" && value.length !== 0) {

            this.setState({
                mobileNo: value,
                disabledMobileSearch: false
            })
        }
        else {
            this.setState({
                disabledMobileSearch: true
            })
        }

    }

    handleClick = () => {
        let _this = this
        localStorage.setItem('cardRefNumber', this.state.cardNumber)
        localStorage.setItem('cardSearchToast', 'first')
        this.props.getCardDetails(this.state.cardNumber)
        setTimeout(function () {
            if (localStorage.getItem('cardSearchToast') === 'second') {
                _this.props.history.push('/carddetails')
            }
        }, 3000)

    }

    handleUserId = () => {
      
        var ciphertext = CryptoJS.AES.encrypt(this.state.userName, 'gmcabs123');
        localStorage.setItem('eu', ciphertext)
        this.props.getUserIdDetails(this.state.userName, this.props.history)
        localStorage.setItem('userIdToast', 'first')
        //    setTimeout(function () {
        //     if (localStorage.getItem('userIdToast') === 'second' ) {
        //         _this.props.history.push('/carddetails')
        //     }
        // },3000)
    }
    handleMobileNo = () => {
   
        var ciphertext = CryptoJS.AES.encrypt(this.state.mobileNo, 'gmcabs123');
        localStorage.setItem('em', ciphertext)
        this.props.getMobileInfoDetails(this.state.mobileNo,this.props.history)
        localStorage.setItem('mobileNoToast', 'first')
        // setTimeout(function () {
        //     if (localStorage.getItem('mobileNoToast') === 'second') {
        //         _this.props.history.push('/mobnodetails')
        //     }
        // }, 3000)
    }
    handleStatusModal = (data) => {
        this.setState({ statusData: data })
    }
      handleCardNo =  () => {
        let _this = this
        var ciphertext = CryptoJS.AES.encrypt(this.state.cardNo, 'gmcabs123');
        localStorage.setItem('ec', ciphertext)
        const { publicKey } = this.props
        const Encrypt = window.JSEncrypt
        const encrypt = new Encrypt()
        encrypt.setPublicKey(publicKey.body.publickey)
        let cardNo = encrypt.encrypt(this.state.cardNo)         
        this.props.getCardNoDetails(cardNo, this.handleStatusModal)
        localStorage.setItem('cardNoToast', 'first')
        setTimeout(function(){
            if (localStorage.getItem('cardNoToast') === 'second') {
                _this.props.history.push('/cardnodetails')
            }
        },3000)
    }
    handleTenDigitCardNo = () => {
        let _this = this
        // var ciphertext = CryptoJS.AES.encrypt(this.state.cardNo, 'gmcabs123');
        // localStorage.setItem('ec', ciphertext)
        this.props.fetchPublicKey()
        const { publicKey } = this.props
        const Encrypt = window.JSEncrypt
        const encrypt = new Encrypt()
        encrypt.setPublicKey(publicKey.body.publickey)
        let cardNo = encrypt.encrypt(localStorage.getItem('cardBin')+ this.state.tendigitcardNo)
        this.props.getCardNoDetails(cardNo, this.handleStatusModal)
        localStorage.setItem('ec', cardNo)
        localStorage.setItem('cardNoToast', 'first')
        setTimeout(function(){
            if (localStorage.getItem('cardNoToast') === 'second') {
                _this.props.history.push('/cardnodetails')
            }
        },3000)
    }
    customerresponse(customerUrl,customerId,publickey,id,cardBin,e,value){
        this.setState({       
            selected: value,
            appId: id,
            cardBin:cardBin,
        })
        // if(this.state.customer !== customerId ){
        //     this.setState({
        //         customerId: 'active'
        //     })
        // }
        // this.props.getCustomerList(this.props.history);
        localStorage.setItem('serviceUrl',customerUrl)
        localStorage.setItem('publicKey',publickey)
        localStorage.setItem('applicationId',id)
        localStorage.setItem('cardBin',cardBin)
        // localStorage.setItem('serviceUrl', 'first')

        this.props.fetchPublicKey()
    }
    renderCustomers() {
        return (
            (Array.isArray(this.props.customerListState.body) && this.props.customerListState.body.length  ) ?
                this.props.customerListState.body.map((customer,i) =>
                    <Card
                        key={customer.applicationId}
                      
                        className={`dashboard-customer-card ${ customer.applicationId === this.state.appId ? 'active': null }`}
                        // variant= "outlined"
                        onClick={(e,value) => {this.customerresponse(this.props.customerListState.body[i].baseURL,this.props.customerListState.body[i].customerId,this.props.customerListState.body[i].publickey,this.props.customerListState.body[i].applicationId,this.props.customerListState.body[i].programBIN, e, value)}}>
                        <CardContent   className= {`dashboard-customer-details-wrap `}  >
                            {/* <div className="customer-main-item" > */}
                                <img
                                    src={customer.customerLogoURL ? (customer.customerLogoURL) : ""}
                                    alt="Customer logo"    
                                    className="image" />
                            {/* </div> */}
                            {/* <div className="text-heading">
                            <span
                                    className="lead"
                                    style={{ fontSize: '17px', display: 'block', marginTop: '10px', fontWeight: '400' }}>
                                    { customer.customerName }
                                </span>
                              </div> */}
                        </CardContent>
                    </Card>
                )
                :
                <React.Fragment>
                    <ShadowCard />
                    <ShadowCard />
                    <ShadowCard />
                    <ShadowCard />
                    <ShadowCard />
                </React.Fragment>
        )
    }

    render() {
     
        const height = $(window).height() + 50 ;
        return (
            <div style={{ minHeight: height }}>
                <div className="col-sm-12">
                    <AdminNavbar />
                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
               {this.state.statusData && <CardStatusModal data={this.state.statusData} handleClose={this.closeStatusModal} />}
                <div className="offset-sm-2 col-sm-8 customers-wrapper text-center" style={{marginTop:"5%"}}>
                  <span className="text-header" style={{fontSize:"18px",fontWeight:"600",marginBottom:"1%"}}> Your Customers</span>
                    <ExpansionPanel
                        style={{ margin: '0 5px' }}
                        expanded={this.state.open}
                        onChange={this.handleAccordion}>
                      {/* <ExpansionPanelSummary>
                        <Typography style={{fontSize:"18px",fontWeight:"600"}}>Your Customers</Typography>
                      </ExpansionPanelSummary> */}
                       
                        <ExpansionPanelDetails
                            style={{ background: '#f0f2f5', display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'nowrap' }} className="customer-card-wrap">
                           
                            <React.Fragment>
                                {this.renderCustomers()}
                            </React.Fragment>
                            {/* <Component  customers={ this.props.customerListState } /> */}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div className="col-sm-12" style={{ marginTop: "2%" }}>
                    <span style={{ fontSize: "25px", fontWeight: "400" }}>
                        Card Search
                    </span>
                </div>
                <div className="col-sm-12" style={{ marginTop: "20px", padding: "0px 30px" }}>
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="col-sm-12" style={{ boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)" }}>
                                <div className="row">
                                    <div className="col-sm-12" style={{ background: "#eeeeee", minHeight: "40px", }}>
                                        <div className="text-center" style={{ fontSize: "19px",marginTop:"5px" }}>Search by Card Reference Number</div>
                                    </div>
                                    <div className="col-sm-12" style={{ padding: "0px" }}>
                                        <div className="row">
                                            <div className="col-sm-5" style={{ textAlign: "right", marginTop: "29px", marginLeft: "18px", padding: "0px" }}>
                                                Card Reference No:
                                </div>
                                            <div className="col-sm-6" style={{ marginTop: "-8px" }}>
                                                <TextField
                                                    hintText="Start Typing"
                                                    floatingLabelText="Reference Number"
                                                    type="text"
                                                    name="cardNumber"
                                                    className="input-width"
                                                    maxLength="15"
                                                    onInput={(e) => {
                                                        e.target.value = Math.max(0, parseInt(e.target.value,10)).toString().slice(0, 15)
                                                    }}
                                                    onChange={this.cardNumber}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                // errorText={homeState ? correcthome ? null : "Not a valid phone number" : "This field is required"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px" }}>
                                        <RaisedButton
                                            label="Search"
                                            // buttonStyle={styles.buttonStyle}
                                            // labelColor="#fff"
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.handleClick}
                                            disabled={this.state.disabled}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <div className="col-sm-12" style={{ boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)" }}>
                                <div className="row">
                                    <div className="col-sm-12" style={{ background: "#eeeeee", minHeight: "40px" }}>
                                        <div className="text-center" style={{ fontSize: "19px",marginTop:"5px" }}>Search by User ID</div>
                                    </div>
                                    <div className="col-sm-12" style={{ padding: "0px" }}>
                                        <div className="row">
                                            <div className="col-sm-5" style={{ textAlign: "right", marginTop: "25px", marginLeft: "18px" }}>
                                                Cardholder User ID:
                                </div>
                                            <div className="col-sm-6" style={{ marginTop: "-8px" }}>
                                                <TextField
                                                    hintText="Start Typing"
                                                    floatingLabelText="User ID"
                                                    type="text"
                                                    name="userId"
                                                    className="input-width"
                                                    maxLength="20"
                                                    onChange={this.userId}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                // errorText={homeState ? correcthome ? null : "Not a valid phone number" : "This field is required"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px" }}>
                                        <RaisedButton
                                            label="Search"
                                            // buttonStyle={styles.buttonStyle}
                                            // labelColor="#fff"
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.handleUserId}
                                            disabled={this.state.disabledUserSearch}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-sm-4" >
                            <div className="col-sm-12" style={{ boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)" }}>
                                <div className="row">
                                    <div className="col-sm-12" style={{ background: "#eeeeee", minHeight: "40px" }}>
                                        <div className="text-center" style={{ fontSize: "19px",marginTop:"5px" }}>Search by Mobile Number</div>
                                    </div>
                                    <div className="col-sm-12" style={{ padding: "0px" }}>
                                        <div className="row">
                                            <div className="col-sm-5" style={{ textAlign: "right", marginTop: "29px", marginLeft: "18px", padding: "0px" }}>
                                                Cardholder Mobile No:
                                </div>
                                            <div className="col-sm-6" style={{ marginTop: "-8px" }}>
                                                <TextField
                                                    hintText="Start Typing"
                                                    floatingLabelText="Mobile Number"
                                                    type="text"
                                                    name="mobileNo"
                                                    className="input-width"
                                                    maxLength="10"
                                                    onChange={this.mobileNo}
                                                    underlineFocusStyle={styles.focusStyle}
                                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                                // errorText={homeState ? correcthome ? null : "Not a valid phone number" : "This field is required"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px" }}>
                                        <RaisedButton
                                            label="Search"
                                            // buttonStyle={styles.buttonStyle}
                                            // labelColor="#fff"
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.handleMobileNo.bind(this)}
                                            disabled={this.state.disabledMobileSearch}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-4" style={{}}>
                    {/* <div className="col-sm-12" style={{ boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)" }}>
                            <div className="row">
                                <div className="col-sm-12" style={{ background: "#eeeeee", minHeight: "40px" }}>
                                    <div className="text-center" style={{ fontSize: "19px",marginTop:"5px" }}>Search by Last 10 Digits Card Number</div>
                                </div>
                                <div className="col-sm-12" style={{ padding: "0px" }}>
                                    <div className="row">
                                        <div className="col-sm-5" style={{ textAlign: "right", marginTop: "29px", marginLeft: "18px", padding: "0px" }}>
                                           Last 10 Digits Card No:
                                        </div>
                                        <div className="col-sm-6" style={{ marginTop: "-8px" }}>
                                            <TextField
                                                hintText="Start Typing"
                                                floatingLabelText="Ten Digit Card No"
                                                type="text"
                                                name="tendigitcardNo"
                                                className="input-width"
                                                maxLength="10"
                                                onChange={this.changeTenDigitCardNo}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            // errorText={homeState ? correcthome ? null : "Not a valid phone number" : "This field is required"}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px" }}>
                                    <RaisedButton
                                        label="Search"
                                        // buttonStyle={styles.buttonStyle}
                                        // labelColor="#fff"
                                        backgroundColor="#333"
                                        labelColor="#fff"
                                        onClick={this.handleTenDigitCardNo}
                                        disabled={this.state.tendigitcardNo.length !== 10}
                                    />
                                </div>
                            </div>
                        </div>
                    </div> */}
                    </div>
                    <div className="col-md-4 p-4" style={{marginBottom:"2%"}}>
                        <div className="col-sm-12" style={{ boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)" }}>
                            <div className="row">
                                <div className="col-sm-12" style={{ background: "#eeeeee",minHeight: "40px" }}>
                                    <div className="text-center" style={{ fontSize: "19px",marginTop:"5px" }}>Search by Card Number</div>
                                </div>
                                <div className="col-sm-12" style={{ padding: "0px" }}>
                                    <div className="row">
                                        <div className="col-sm-4" style={{ textAlign: "right", marginTop: "29px", marginLeft: "18px", padding: "0px" }}>
                                            Card No:
                                        </div>
                                        <div className="col-sm-7" style={{ marginTop: "-8px" }}>
                                            <TextField
                                                hintText="Start Typing"
                                                floatingLabelText="Card No"
                                                type="text"
                                                name="cardNo"
                                                className="input-width"
                                                maxLength="16"
                                                onChange={this.changeCardNo}
                                                underlineFocusStyle={styles.focusStyle}
                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                            // errorText={homeState ? correcthome ? null : "Not a valid phone number" : "This field is required"}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px" }}>
                                    <RaisedButton
                                        label="Search"
                                        // buttonStyle={styles.buttonStyle}
                                        // labelColor="#fff"
                                        backgroundColor="#333"
                                        labelColor="#fff"
                                        onClick={this.handleCardNo}
                                        disabled={this.state.cardNo.length !== 16}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4"></div>
                </div>

            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardSearch);


// WEBPACK FOOTER //
// ./src/components/adminuser/cardsearch.jsx